module.exports = __webpack_public_path__ + "media/Bory_Na_Hradzi_video.e16409e5.mp4";